<div class="modal-header">
  <h2 class="modal-title">
    {{ 'courseModule.duplicateCourse' | translate }}
  </h2>
  <button
    type="button"
    class="btn-close"
    attr.aria-label="{{ 'general.close' | translate }}"
    (click)="onClose()"
  ></button>
</div>
<div class="modal-body">
  <div class="card-body">
    <div
      class="d-flex gx-2 mb-2 align-items-center justify-content-around"
      *ngFor="let course of duplicatedCourses"
    >
      <p class="mb-0">{{ course.description }}</p>
      <div class="d-flex gx-2 mb-2 align-items-center justify-content-around">
        <button
          type="button"
          class="btn btn-soft-primary"
          data-dismiss="modal"
          (click)="onView(course)"
        >
          {{ 'general.view' | translate }}
        </button>
        <button
          type="button"
          class="btn btn-soft-success"
          data-dismiss="modal"
          (click)="onCreateBooking(course)"
        >
          {{ 'bookingModule.createBooking' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer justify-content-between">
  <button
    type="button"
    class="btn btn-white"
    data-dismiss="modal"
    (click)="onClose()"
  >
    {{ 'general.close' | translate }}
  </button>
</div>
